export default __webpack_public_path__ + "static/media/AcornMallFastFood_01.8c2b6085.png";